import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { SearchBar, SearchResultGrid, ModelDetailPanel } from '@/features/search/components'
import { PageLayout } from '@/shared/components'

interface SelectedModel {
  readonly provider: string
  readonly externalId: string
}

export function SearchPage() {
  const { t } = useTranslation()

  const [query, setQuery] = useState('')
  const [provider, setProvider] = useState<string | undefined>(undefined)
  const [resourceType, setResourceType] = useState<string | undefined>(undefined)
  const [selectedModel, setSelectedModel] = useState<SelectedModel | undefined>(undefined)

  const handleSearch = useCallback(
    (q: string, prov: string | undefined, resType: string | undefined) => {
      setQuery(q)
      setProvider(prov)
      setResourceType(resType)
      setSelectedModel(undefined)
    },
    [],
  )

  const handleSelectItem = useCallback(
    (item: { provider: string; externalId: string }) => {
      setSelectedModel({ provider: item.provider, externalId: item.externalId })
    },
    [],
  )

  const handleCloseDetail = useCallback(() => {
    setSelectedModel(undefined)
  }, [])

  if (selectedModel !== undefined) {
    return (
      <PageLayout title={t('search.title')}>
        <ModelDetailPanel
          provider={selectedModel.provider}
          externalId={selectedModel.externalId}
          onClose={handleCloseDetail}
        />
      </PageLayout>
    )
  }

  return (
    <PageLayout
      title={t('search.title')}
      headerExtra={
        <SearchBar onSearch={handleSearch} />
      }
    >
      {query.length >= 2 ? (
        <SearchResultGrid
          query={query}
          provider={provider}
          resourceType={resourceType}
          onSelectItem={handleSelectItem}
        />
      ) : (
        <div className="py-12 text-center">
          <p className="text-tg-hint">
            {t('search.hint')}
          </p>
        </div>
      )}
    </PageLayout>
  )
}
